import TableCell, { TableCellProps } from '@mui/material/TableCell';
import React from 'react';
import './table.scss';

export const AppTableCellHeader = (props: TableCellProps) => (
	<TableCell {...props} className={`app-table-cell-header ${props.className || ''}`}>
		{props.children}
	</TableCell>
);
